const inviteUserWidget = {
  openButton: "+ Invite User",
  heading: "Invite User to a Project",
  emailLabel: "Email:",
  emailPlaceholder: "user@example.com",
  projectLabel: "Project:",
  roleLabel: "Role:",
  roleResearcher: "Researcher",
  rolePi: "PI (Principal Investigator)",
  expiryLabel: "Expires in:",
  expiryOptions: {
    hours24: "24 hours (1 day)",
    hours72: "72 hours (3 days)",
    hours168: "168 hours (7 days)",
    hours336: "336 hours (14 days)",
    hours720: "720 hours (30 days)",
  },
  sendButton: "Send Invitation",
  sending: "Sending...",
  successMessage: 'Invitation sent to {{email}} for project "{{project}}".',
  errorFallback: "Failed to send invitation.",
};

export default inviteUserWidget;
